module.exports = __webpack_public_path__ + "static/media/TidyHive.5074428d.jpg";